import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Commission from "./pages/commission";
import "./App.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import MyZone from "./pages/my-zone";
import ContactMe from "./pages/contact-me";

function App() {
  useEffect(() => {
    const cursor = document.createElement("div");
    cursor.classList.add("custom-cursor");
    document.body.appendChild(cursor);

    const createSparkle = (e) => {
      const sparkle = document.createElement("div");
      sparkle.classList.add("sparkle");

      document.body.appendChild(sparkle);

      sparkle.style.left = `${e.pageX}px`;
      sparkle.style.top = `${e.pageY}px`;

      setTimeout(() => {
        sparkle.remove();
      }, 500);
    };

    const handleMouseMove = (e) => {
      const cursorSize = 16;
      cursor.style.left = `${e.clientX - cursorSize}px`;
      cursor.style.top = `${e.clientY - cursorSize}px`;

      createSparkle(e);
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      cursor.remove();
    };
  }, []);
  return (
    <Router>
      <div className="app-container">
        <div className="container">
          <Helmet>
            <title>Mildmisaki</title>
          </Helmet>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/commission" element={<Commission />} />
            <Route path="/my-zone" element={<MyZone />} />
            <Route path="/contact-me" element={<ContactMe />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
